import { createStyles, makeStyles } from '@material-ui/core';
import { monolithEmbeddedStartsM, monolithLStarts } from './EmbeddedSignUpTypes';
export var useSocialButtonStyles = makeStyles(function (_a) {
    var _b;
    var spacing = _a.spacing, palette = _a.palette, typography = _a.typography;
    return createStyles({
        root: {
            height: spacing(5),
            width: '100%',
            border: spacing(0.125),
            backgroundColor: palette.common.white,
            borderStyle: 'solid',
            borderColor: palette.border.main,
            borderRadius: spacing(0.5),
            letterSpacing: spacing(0.025),
            fontWeight: typography.fontWeightBold,
            fontFamily: typography.fontFamily,
            fontSize: typography.fontSize * 1.07,
            '&.Mui-disabled': {
                cursor: 'default',
                color: palette.common.white,
                borderStyle: 'none',
                backgroundColor: '#dcdee1',
            },
        },
        label: {
            justifyContent: 'flex-start',
        },
        startIcon: {
            marginRight: spacing(5.875),
        },
        startIconDisabled: {
            marginRight: spacing(14.375),
        },
        root_loh: {
            height: spacing(5),
            width: '100%',
            border: spacing(0.125),
            backgroundColor: palette.common.white,
            borderStyle: 'solid',
            borderColor: palette.border.disabled,
            borderRadius: spacing(0.5),
            letterSpacing: spacing(0.025),
            fontWeight: typography.fontWeightBold,
            fontFamily: typography.fontFamily,
            fontSize: typography.fontSize * 1.07,
            '&.Mui-disabled': {
                cursor: 'default',
                color: palette.common.white,
                borderStyle: 'none',
                backgroundColor: '#dcdee1',
            },
            '&:hover': {
                backgroundColor: palette.paper.canvas,
            },
        },
        label_loh: {
            justifyContent: 'flex-start',
        },
        startIcon_loh: (_b = {
                marginRight: 54
            },
            _b["@media (min-width:" + monolithEmbeddedStartsM + "px)"] = {
                marginRight: 20,
            },
            _b["@media (min-width:" + monolithLStarts + "px)"] = {
                marginRight: 40,
            },
            _b),
        startIconDisabled_loh: {
            marginRight: 92,
        },
    });
});
//# sourceMappingURL=SocialButtonStyles.js.map